module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAGFBMVEVHcEybf/eZfPibf/ebfvebfvebevSZfvecx+EUAAAACHRSTlMAfyFUZ3YLMnEKHugAAAA9SURBVDjLY2AYBSMRMJkGK2BQIKAiKOiEQYGAoaCgcAIDGxIFlQgUFBQBijjCKVFCEjiNwmk5TueOgpEFAMXoD62IpVFQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trends/dyn_dyn_ic_more.png
// module id = 8Ghu
// module chunks = 1